module.exports = __webpack_public_path__ + "static/img/05.21c2828.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hhxnsx/05.jpg
// module id = mmIm
// module chunks = 1